module.exports = __webpack_public_path__ + "static/media/Slice2.04e59436.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/Slice2.png
// module id = 1496
// module chunks = 0